import styled from 'styled-components';

// Shared CSS-grid primitives for the Community disclosure report tables —
// the by-source table on the Overview page and the measure-class table on a
// source page. A bespoke grid (like gpc-summary-table) gives aligned columns
// and a uniform row height, so a per-row `ShareBar` lines up with its text.
// `$columns` is the caller's `grid-template-columns` (the two tables differ
// in column count). Labels left-align; numeric columns right-align via
// `Cell`'s `$align`. The magnitude bar sits right after the label column.
const DisclosureTable = styled<any>('div')(
  ({ theme }: any) => ({
    display: 'grid',
    alignItems: 'center',
    columnGap: 16,
    rowGap: 4,
    gridAutoRows: 28,
    fontSize: theme.fontSize.medium,
    width: '100%',
  }),
  ({ $columns }: any) => ({ gridTemplateColumns: $columns }),
);

// One grid cell. `$heading` renders the column header / total row in bold;
// `$align='right'` right-aligns numeric columns (CO₂-e, %, activity) — labels
// keep the default left. `$indent` left-pads a nested label (an activity row
// under its source, when a source is expanded) so the nesting reads visually
// while the row keeps the same magnitude line as its parent. Long labels
// ellipsis rather than wrap (rows stay one line high).
const Cell = styled<any>('div')(({ $heading, $align, $indent }: any) => ({
  fontWeight: $heading ? 'bold' : 'normal',
  textAlign: $align ?? 'left',
  paddingLeft: $indent ? 16 : undefined,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export { DisclosureTable, Cell };
